<template>
  <div ref="signaturediv">
    <table cellpadding="0" cellspacing="0" border="0" style="font-family: Arial, Helvetica, sans-serif; color: #101010; font-size: 13px; line-height: 1.5;">
      <tbody>

        <!-- Greeting -->
        <tr>
          <td colspan="4" style="padding-bottom: 20px;">
            <span style="font-size: 14px; color: #101010; line-height: 1;">Met vriendelijke groet / Kind regards,</span>
          </td>
        </tr>

        <!-- Horizontal line -->
        <tr>
          <td colspan="4" style="height: 1px; font-size: 1px; line-height: 1px; background-color: #ddd;">&nbsp;</td>
        </tr>

        <!-- Spacer between line and signature -->
        <tr>
          <td colspan="4" height="20"></td>
        </tr>

        <!-- Signature -->
        <tr>
          <!-- Logo -->
          <td style="vertical-align: top; padding-right: 20px;">
            <img src="https://signature.wearefrank.nl/wearefrank-signature.png"
                 alt="WeAreFrank!" width="60"
                 style="display: block; border: 0; outline: none; text-decoration: none;">
          </td>

          <!-- Yellow vertical divider -->
          <td style="width: 3px; background-color: #fdc300;" width="3"></td>

          <!-- Spacer -->
          <td style="width: 20px;" width="20"></td>

          <!-- Name + Title + Contact + CTA -->
          <td style="vertical-align: top;">
            <!-- Name -->
            <table cellpadding="0" cellspacing="0" border="0">
              <tbody>
                <tr v-if="!data.tussenvoegsel">
                  <td style="font-size: 16px; font-weight: bold; color: #101010; line-height: 1.3; padding-bottom: 2px;">
                    {{data.firstname}} {{data.lastname}}
                  </td>
                </tr>
                <tr v-if="data.tussenvoegsel">
                  <td style="font-size: 16px; font-weight: bold; color: #101010; line-height: 1.3; padding-bottom: 2px;">
                    {{data.firstname}} {{data.tussenvoegsel}} {{data.lastname}}
                  </td>
                </tr>

                <!-- Function -->
                <tr>
                  <td style="font-size: 13px; color: #101010; padding-bottom: 10px;">
                    {{data.func}}
                  </td>
                </tr>

                <!-- Contact details -->
                <tr>
                  <td style="font-size: 12px; color: #101010; line-height: 1.7;">
                    <span v-if="data.email"><a :href="'mailto:' + data.email" style="color: #101010; text-decoration: none;"><span style="color: #101010; text-decoration: none;">{{data.email}}</span></a><br></span>
                    <span v-if="data.phone"><a :href="data.phoneNumber.uri" style="color: #101010; text-decoration: none;"><span style="color: #101010; text-decoration: none;">{{data.phoneNumber.formatNational}}</span></a></span>
                  </td>
                </tr>

                <!-- CTA spacer -->
                <tr v-if="data.marketing.type != ''">
                  <td height="12"></td>
                </tr>

                <!-- CTA: Blog -->
                <tr v-if="data.marketing.type == 'tvblog'">
                  <td style="font-size: 12px;">
                    <a href="https://wearefrank.nl/insights?utm_source=email_signature&utm_medium=email"
                       style="color: #101010; text-decoration: none; border-bottom: 2px solid #fdc300; padding-bottom: 1px; font-weight: bold;">
                      <span style="color: #101010; text-decoration: none;">Bekijk Frank!Insights &rarr;</span>
                    </a>
                  </td>
                </tr>

                <!-- CTA: Book a meeting -->
                <tr v-if="data.marketing.type == 'adviesgesprek'">
                  <td style="font-size: 12px;">
                    <a :href="data.marketing.link"
                       style="color: #101010; text-decoration: none; border-bottom: 2px solid #fdc300; padding-bottom: 1px; font-weight: bold;">
                      <span style="color: #101010; text-decoration: none;">Plan een afspraak &rarr;</span>
                    </a>
                  </td>
                </tr>

                <!-- CTA: Custom -->
                <tr v-if="data.marketing.type == 'aangepast'">
                  <td style="font-size: 12px;">
                    <a :href="data.marketing.link"
                       style="color: #101010; text-decoration: none; border-bottom: 2px solid #fdc300; padding-bottom: 1px; font-weight: bold;">
                      <span style="color: #101010; text-decoration: none;">{{data.marketing.text}} &rarr;</span>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>

        <!-- Spacer before footer -->
        <tr>
          <td colspan="4" height="12"></td>
        </tr>

        <!-- Office address -->
        <tr>
          <td colspan="4" style="font-size: 11px; color: #888; line-height: 1.4;">
            <span style="color: #888;">WeAreFrank!</span>
            <span style="color: #fdc300;"> &bull; </span>
            <span style="color: #888;">Westersingel 42</span>
            <span style="color: #fdc300;"> &bull; </span>
            <span style="color: #888;">3014 GT Rotterdam</span>
          </td>
        </tr>
        <tr>
          <td colspan="4" style="font-size: 11px; color: #888; line-height: 1.4;">
            <a href="tel:+31103405010" style="color: #888; text-decoration: none;"><span style="color: #888; text-decoration: none;">010-3405010</span></a>
            <span style="color: #fdc300;"> &bull; </span>
            <a href="https://wearefrank.nl?utm_source=email_signature&utm_medium=email" style="color: #888; text-decoration: none;"><span style="color: #888; text-decoration: none;">WeAreFrank.nl</span></a>
            <span style="color: #fdc300;"> &bull; </span>
            <a href="https://www.linkedin.com/company/wearefrank/" style="color: #888; text-decoration: none;"><span style="color: #888; text-decoration: none;">LinkedIn</span></a>
          </td>
        </tr>

      </tbody>
    </table>
  </div>
</template>

<script>
export default {
 name: 'SignatureComponent',
 props: {
    data: Object,
 }
};
</script>
